import { render, staticRenderFns } from "./SopNavigationTree.vue?vue&type=template&id=50253c4b&"
import script from "./SopNavigationTree.vue?vue&type=script&lang=ts&"
export * from "./SopNavigationTree.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports